import script from "./home.vue?vue&type=script&lang=ts&setup=true"
export * from "./home.vue?vue&type=script&lang=ts&setup=true"

import "./home.vue?vue&type=style&index=0&id=c14d9398&lang=scss"

const __exports__ = script;

export default __exports__